export const SUCCESS_LIBRARY_FILTERS = "SUCCESS_LIBRARY_FILTERS";
export const LOADING_LIBRARY_FILTERS = "LOADING_LIBRARY_FILTERS";

export const FilterTypes = {
	SUCCESS_LIBRARY_FILTERS,
	LOADING_LIBRARY_FILTERS
}
